// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
  margin: 0;
  padding: 0;
  font-size: 16px;
  word-wrap: break-word;
  width: 100%;
  height: 100%;
  background-color: #fff;
  -webkit-overflow-scrolling: touch;
}

body {
  position: relative;
  overflow: hidden;
  font-family: 'Raleway', sans-serif;
  /* for iOS Safari */
  touch-action: manipulation;
  touch-action: none;
}

.pdf-document, #app {
  height: 100%;
}

img {
  max-width: 100%;
}

* {
  box-sizing: border-box;
}

@media print {
  html,
  body {
    font-size: 12px;
  }
  html,
  body,
  div {
    width: auto;
    height: auto !important;
    float: none !important;
    position: static !important;
    overflow: visible !important;
    page-break-inside: auto;
  }
}

@media print {
  -moz-appearance: number-input;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./assets/css/defaults.css"],"names":[],"mappings":"AAAA;;EAEE,SAAS;EACT,UAAU;EACV,eAAe;EACf,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;;IAEE,eAAe;EACjB;EACA;;;IAGE,WAAW;IACX,uBAAuB;IACvB,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;IAC5B,uBAAuB;EACzB;AACF;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["html,\nbody {\n  margin: 0;\n  padding: 0;\n  font-size: 16px;\n  word-wrap: break-word;\n  width: 100%;\n  height: 100%;\n  background-color: #fff;\n  -webkit-overflow-scrolling: touch;\n}\n\nbody {\n  position: relative;\n  overflow: hidden;\n  font-family: 'Raleway', sans-serif;\n  /* for iOS Safari */\n  touch-action: manipulation;\n  touch-action: none;\n}\n\n.pdf-document, #app {\n  height: 100%;\n}\n\nimg {\n  max-width: 100%;\n}\n\n* {\n  box-sizing: border-box;\n}\n\n@media print {\n  html,\n  body {\n    font-size: 12px;\n  }\n  html,\n  body,\n  div {\n    width: auto;\n    height: auto !important;\n    float: none !important;\n    position: static !important;\n    overflow: visible !important;\n    page-break-inside: auto;\n  }\n}\n\n@media print {\n  -moz-appearance: number-input;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
